import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	.content-section {
		display: flex;
		width: 100%;
	}
	.buttons-section {
		display: flex;
		width: 100%;
		justify-content: end;
		border-top: var(--template-separator);
	}
`;
